import styled from 'styled-components';

const MOBILE_BREAKPOINT = '768px';

export const Container = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 82px 24px 24px;
  background-color: #fff;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  overflow-x: hidden;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    padding: 96px 16px 16px;
  }
`;

export const LogoContainer = styled.div`
  margin-bottom: 16px;
  text-align: center;
`;

export const Logo = styled.img`
  max-width: 262px;
  width: 100%;
  height: 82px;
  object-fit: contain;
`;

export const Card = styled.div`
  width: 100%;
  max-width: 660px;
  min-width: 0;
  background: ${({ theme }) => theme.tokens?.color?.surface?.primary || '#fff'};
  border-radius: 12px;
  padding: 16px 32px 32px;
  text-align: center;
  box-shadow: none;
  border: none;
  box-sizing: border-box;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    padding: 16px;
  }
`;

export const IconWrapper = styled.div`
  position: relative;
  display: inline-flex;
  margin-bottom: 24px;

  img {
    max-height: 96px;
    width: auto;
    display: block;
  }
`;

export const Title = styled.h1`
  font-size: 1.75rem;
  font-weight: 700;
  color: #070B64;
  margin: 0 0 24px;
  font-family: 'LATAM Sans Regular', 'LATAM Sans', sans-serif;
  text-align: center;
`;

export const ResubscribeText = styled.p`
  font-size: 1.125rem;
  color: ${({ theme }) => theme.tokens?.color?.text?.secondary || '#666'};
  margin: 24px 0 40px 0;
  font-family: 'LATAM Sans Regular', 'LATAM Sans', sans-serif;

  a {
    color: inherit;
    text-decoration: underline;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 24px;
  width: 100%;

  button {
    min-width: 200px;
    width: 100%;
    max-width: 280px;

    @media (max-width: ${MOBILE_BREAKPOINT}) {
      min-width: unset;
      max-width: 100%;
    }
  }
`;
